import React from 'react';
import PropTypes from 'prop-types';
import CancelAppointmentModal from './CancelAppointmentModal';

const Modals = ({
  confirmModal,
  closeConfirmModal,
  cancelAppointment,
}) => (
  <div>
    <CancelAppointmentModal
      isOpen={confirmModal.open}
      closeModal={closeConfirmModal}
      onConfirm={cancelAppointment}
    />
  </div>
);
Modals.propTypes = {
  confirmModal: PropTypes.shape({ open: PropTypes.bool }).isRequired,
  closeConfirmModal: PropTypes.func.isRequired,
  cancelAppointment: PropTypes.func.isRequired,
};
export default Modals;



// WEBPACK FOOTER //
// ./src/app/reservation/components/Modals.jsx